import LazyLoad from 'vanilla-lazyload';

import BlogPostManager from '@d-shared/blog/blog-post-manager';

const BLOG_PATHNAME_PREFIX = '/discovery/blog';

export default {
  initialize: async (Vue) => {
    // Wait for Vue to process the DOM
    await Vue.nextTick();

    new LazyLoad({
      elements_selector: 'img[data-src]',
    });

    (new BlogPostManager).install();
  },

  install: function(Vue) {
    if (!document.location.pathname.startsWith(BLOG_PATHNAME_PREFIX)) {
      return;
    }

    this.initialize(Vue);
  },
};
